//VisibilityOff
import { Google } from '@mui/icons-material';
import {  Button } from '@mui/material';
import {useGoogleLogin} from '@react-oauth/google';
import React from 'react';
import { useTranslation } from 'react-i18next';
// import "./Register.style.scss"
import Swal from 'sweetalert2';

import axios from '../../Api/axios';
import useAuthSetState from '../../hooks/useAuthSetState';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
//import PropTypes from 'prop-types';
function ConnectOAuth2(width='auto') {
    //ConnectOAuth2.propTypes={
    //    width:PropTypes.any,
    //};

    const {setAuthState,RedirectRoleAndFromBased} = useAuthSetState();
    const { i18n } = useTranslation();
    function handleGoogleLoginSuccess(tokenResponse) {
        const googleAccessToken = tokenResponse.access_token;
        console.log(googleAccessToken);
        fetch(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${googleAccessToken}`, {
            method: 'get',
        })
            .then(resp => resp.json())
            .then(googleOAuth2Data => {
                // setUrl(data.url);
                console.log(googleOAuth2Data);
                axios.post('auth/login_2FA',
                    { googleAccessToken, googleOAuth2Data },
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    })
                    .then(function (response) {
                        console.log('recieved token 1st step create account = \n' + response.data);
                        // 202 = Accepted == Normal Login = AT & RT recieved
                        setAuthState({responseData: response.data});
                        RedirectRoleAndFromBased({role: response?.data?.user?.role});
                    })
                    .catch(function (error) {
                        // setSignupError(error.response.data?.error)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.response.data?.error,
                        });
                        console.log(error.response.status); // 401
                        console.log('error== ' + error.response.data?.error);
                    });
            })
            .catch(err => console.log(err));
    }
    const login = useGoogleLogin({onSuccess: handleGoogleLoginSuccess});

    return (
        <Button
            onClick={() => login()}
            style={{
                ...buttonStyles(false),...{width:{width}}
            }}
            startIcon={<Google style={{color:'red'}}/>}
            variant="outlined"
        >
            {i18n.t('Connectez-vous avec Google')}
        </Button>
    );
}

export default ConnectOAuth2;